import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const TagService = {
  getTagList(flag = "") {
    return axios.get(`${cleanedBackendUrl}/tag`, {
      params: {
        flag: flag,
      },
    });
  },
  getTagListPageable(page, perPage, flag, search) {
    return axios.get(`${cleanedBackendUrl}/tag/pageable`, {
      params: {
        page: page,
        perPage: perPage,
        flag: flag,
        title: search
      },
    });
  },
  getShownTagList(flag = "") {
    return axios.get(`${cleanedBackendUrl}/tag/shown`, {
      params: {
        flag: flag,
      },
    });
  },
  insertTag(title, description, flag, shown, images, showOrder) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("flag", flag);
    formData.append("shown", shown);
    formData.append("showOrder", showOrder);
    images.forEach(image => {
      formData.append("images", image.originalFile);
    })

    return axios.post(`${cleanedBackendUrl}/tag`, formData);
  },
  updateTag(id, title, description, shown, images, oldImages, showOrder) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("shown", shown);
    formData.append("showOrder", showOrder);
    images.forEach(image => {
      formData.append("images", image.originalFile);
    })
    oldImages.forEach(image => {
      formData.append("oldImages[]", image);
    })

    return axios.patch(`${cleanedBackendUrl}/tag/${id}`, formData);
  },
  deleteTag(id) {
    return axios.delete(`${cleanedBackendUrl}/tag/${id}`)
  },
  getTagBySlug(slug) {
    return axios.get(`${cleanedBackendUrl}/tag/slug/${slug}`);
  }
};

export default TagService;
